<template>
  <el-dialog
    :title="edgeDialog.type === 'edit' ? '编辑知识点关系' : '新增知识点关系'"
    :visible.sync="edgeDialog.visible"
    width="600px"
    @close="edgeDialogClose"
    @open="getListKnowledgeWithChapter"
  >
    <el-form :model="edgeDialog.form" label-width="120px" :rules="edgeRules" ref="edgeFormRef">
      <el-form-item label="起始知识点" prop="sourceKnowledgeId">
        <el-cascader
          :options="newChapterListData"
          :props="cascaderProps"
          v-model="edgeDialog.form.sourceKnowledgeId"
          placeholder="请选择"
          clearable
          :show-all-levels="false"
          :disabled="sourcePreset"
          style="width: 100%;"
        />
      </el-form-item>
      <el-form-item label="关联知识点" prop="targetKnowledgeId">
        <el-cascader
          :options="newChapterListData"
          :props="cascaderProps"
          v-model="edgeDialog.form.targetKnowledgeId"
          placeholder="请选择"
          clearable
          :show-all-levels="false"
          style="width: 100%;"
        />
      </el-form-item>
      <el-form-item label="知识点关系" prop="relationType">
        <el-select v-model="edgeDialog.form.relationType" placeholder="请选择" clearable>
          <el-option
            v-for="(item, index) in relationTypeList"
            :key="index"
            :label="item.text"
            :value="index"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="edgeDialogClose">取消</el-button>
      <el-button type="primary" @click="edgeSubmit">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { relationSave, knowledgeWithChapter } from '@/request/api/knowledge_graph.js'

export default {
  name: 'KgEdgeDialog',
  inject: ['edgeDialog', 'relationTypeList', 'getknowledgeData', 'courseId'],
  data() {
    return {
      sourcePreset: false,
      newChapterListData: [],
      cascaderProps: {
        emitPath: false,
        label: 'name',
        value: 'id',
      },
      edgeRules: {
        sourceKnowledgeId: [{ required: true, message: '请选择起始知识点', trigger: 'change' }],
        targetKnowledgeId: [{ required: true, message: '请选择关联知识点', trigger: 'change' }],
        relationType: [{ required: true, message: '请选择知识点关系', trigger: 'change' }],
      },
    }
  },
  methods: {
    getListKnowledgeWithChapter() {
      // 判断起始知识点是否预填（从知识点列表点添加关系时）
      this.sourcePreset = !!this.edgeDialog.form.sourceKnowledgeId
      knowledgeWithChapter({ courseId: this.courseId.value }).then(res => {
        if (res.code == 0 && res.data) {
          this.newChapterListData = this.transformStructure(res.data)
        }
      })
    },
    transformStructure(data) {
      // 构建三级结构：章 → 节 → 知识点（章和节可展开导航，只有知识点可最终选中）
      return (data || []).map(function (chapter) {
        var chapterNode = {
          id: 'chapter_' + chapter.id,
          name: chapter.name,
          children: [],
        }
        // 章下的节
        var sections = chapter.chapters || chapter.children || []
        sections.forEach(function (section) {
          var sectionNode = {
            id: 'section_' + section.id,
            name: section.name,
            children: [],
          }
          // 节下的知识点
          var knowledges = section.knowledges || []
          knowledges.forEach(function (k) {
            sectionNode.children.push({
              id: k.id,
              name: k.name,
            })
          })
          if (sectionNode.children.length) {
            chapterNode.children.push(sectionNode)
          }
        })
        // 章直属的知识点（如果有）
        var chapterKnowledges = chapter.knowledges || []
        chapterKnowledges.forEach(function (k) {
          chapterNode.children.push({
            id: k.id,
            name: k.name,
          })
        })
        return chapterNode
      })
    },
    edgeDialogClose() {
      this.edgeDialog.visible = false
      this.edgeDialog.type = 'add'
      this.edgeDialog.form = { relationType: 0, sourceKnowledgeId: '', targetKnowledgeId: '' }
    },
    edgeSubmit() {
      this.$refs.edgeFormRef.validate(valid => {
        if (valid) {
          var form = this.edgeDialog.form
          var params = {
            id: form.id,
            relationType: form.relationType,
            sourceKnowledgeId: form.sourceKnowledgeId,
            targetKnowledgeId: form.targetKnowledgeId,
            courseId: this.courseId.value,
          }
          relationSave(params).then(res => {
            if (res.code != 0) return this.$message.error(res.msg || '操作失败')
            this.$message.success('操作成功')
            this.edgeDialogClose()
            this.getknowledgeData()
          })
        }
      })
    },
  },
}
</script>
